import { Loader2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const LoadingScreen = () => {
    const { t } = useLanguage();

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-[#1a0f0f]">
            <div className="flex flex-col items-center space-y-4">
                <Loader2 className="h-12 w-12 animate-spin text-primary" />
                <p className="font-serif text-lg tracking-wider text-primary">
                    Włoska Piwnica
                </p>
            </div>
        </div>
    );
};

export default LoadingScreen;
